<template>
  <v-card>
    <h1 class="text-pagename text-xs-center">Set maintenance app</h1>
    <v-card-text class="pt-0" v-if="!is_crop_image">
      <div class="text-xs-center">Recommended size : (920 x 1800)</div>
      <v-layout row wrap justify-center align-center>
        <v-flex xs12 sm3 class="pr-2 mx-4">
          <v-card :class="!maintenance_data.maintenance_status ? 'filter-close' : '' ">
            <v-switch
              :disabled="isEditMaintance"
              color="primary"
              v-model="maintenance_data.maintenance_status"
              style="position:absolute;right:10px;z-index:10;"
            ></v-switch>
            <v-responsive :aspect-ratio="0.51/1">
              <v-img :src="maintenance_data.maintenance_image">
                <v-tooltip top>
                  <v-btn
                    fab
                    :disabled="isEditMaintance"
                    small
                    @click="$refs.ImageInput.click()"
                    depressed
                    class="add-btn elevation-5"
                    slot="activator"
                  >
                    <v-icon>edit</v-icon>
                  </v-btn>
                  <input
                    style="display:none;"
                    @change="onImageSelected"
                    type="file"
                    ref="ImageInput"
                    accept="image/*"
                  />
                  <span>Edit image</span>
                </v-tooltip>
              </v-img>
              <v-tooltip top v-if="!maintenance_data.maintenance_image">
                <v-btn
                  :disabled="isEditMaintance"
                  fab
                  small
                  @click="$refs.ImageInput.click()"
                  depressed
                  class="add-btn elevation-5"
                  slot="activator"
                >
                  <v-icon>add</v-icon>
                </v-btn>
                <input
                  style="display:none;"
                  @change="onImageSelected"
                  type="file"
                  ref="ImageInput"
                  accept="image/*"
                />
                <span>Add image</span>
              </v-tooltip>
            </v-responsive>
          </v-card>
          <div style="display:flex;justify-content:center;">
            <v-btn
              color="red"
              flat
              @click="reset()"
              :disabled="posting_data || isEditMaintance"
            >Reset</v-btn>
            <v-btn
              color="green"
              flat
              @click="save()"
              :disabled="posting_data || isEditMaintance"
              :loading="posting_data"
            >Save</v-btn>
          </div>
        </v-flex>
      </v-layout>
    </v-card-text>
    <v-card-text v-else>
      <imageCropper
        :aspectRatio="0.51/1"
        :imageName="image_name"
        :imgSrc="imgURL"
        :height="300"
        @close="is_crop_image = false"
        @setImageName="image_name = $event"
        @getCroped="getCropped($event)"
        v-if="imgURL != ''"
      ></imageCropper>
    </v-card-text>
    <v-divider />
  </v-card>
</template>

<script>
import imageCropper from "@/components/Plugins/imageCropper.vue";
import { mapState, mapGetters } from "vuex";
export default {
  components: {
    imageCropper
  },
  data: () => ({
    original_maintenance_data: {},
    change_image: 0,
    image_name: "",
    is_crop_image: false,
    posting_data: false,
    imgURL: null,
    rules: {
      required: value => !!value || "Required."
    }
  }),
  computed: {
    ...mapState({
      maintenance_data: state => state.fetchFoodSetAppBack.maintenance_data
    }),
    ...mapGetters(["isEditMaintance"])
  },
  methods: {
    async save() {
      this.posting_data = true;
      let obj1 = JSON.parse(JSON.stringify(this.maintenance_data));
      if (this.change_image == 0) {
        delete obj1.maintenance_image;
      }
      let check = await this.$store.dispatch(
        "fetchFoodSetAppBack/updateMaintenaceData",
        obj1
      );
      if (check == true) {
        this.change_image = 0;
        this.original_maintenance_data = JSON.parse(
          JSON.stringify(this.maintenance_data)
        );
      }
      this.posting_data = false;
    },
    reset() {
      this.change_image = 0;
      this.$store.commit(
        "fetchFoodSetAppBack/getMaintenanceData",
        JSON.parse(JSON.stringify(this.original_maintenance_data))
      );
    },
    onImageSelected(event) {
      let file = event.target.files[0];
      this.image_name = file.name;
      let reader = new FileReader();
      reader.addEventListener("load", () => {
        this.imgURL = reader.result;
        this.is_crop_image = true;
      });
      reader.readAsDataURL(file);
      event.target.value = "";
    },
    getCropped(image_value) {
      this.maintenance_data.maintenance_image = image_value;
      this.change_image = 1;
      this.imgURL = null;
      this.image_name = "";
    },
    async initialization() {
      await this.$store.dispatch("fetchFoodSetAppBack/getMaintenanceData");
      this.original_maintenance_data = JSON.parse(
        JSON.stringify(this.maintenance_data)
      );
    }
  },
  destroyed() {
    this.$store.commit("fetchFoodSetAppBack/resetState");
  },
  created() {
    this.initialization();
  },
  mounted() {
    const path = [
      {
        text: "Select province",
        disabled: false,
        href: "/weserve_admin_login/select/"
      },
      {
        text: "Set maintenance",
        disabled: true
      }
    ];
    this.$store.commit("backOffice/saveRecentRoute", path);
  }
};
</script>

<style scoped>
.add-btn {
  top: 42%;
  left: 40%;
}
.filter-close {
  background-color: gray;
  opacity: 0.5;
  transition: 0.5s;
  width: 100%;
  height: 100%;
}
</style>
